export default __webpack_public_path__ + "static/inkypen-3a3511dcc3207a6da101f44f1cb81db0.png";